import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { defaultLocale } from '../app/config';
import { en } from './locales/en';
import { ru } from './locales/ru';

void i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    ru: {
      translation: ru,
    },
  },
  lng: defaultLocale,
  fallbackLng: defaultLocale,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
